import { EnableRuleAction } from './EnableRuleAction';
import { EnableRuleSuccessAction } from './EnableRuleSuccessAction';
import { DisableRuleAction } from './DisableRuleAction';
import { DisableRuleSuccessAction } from './DisableRuleSuccessAction';
import { UpdateRuleStatusAction } from './UpdateRuleStatusAction';
import { UpdateRuleStatusSuccessAction } from './UpdateRuleStatusSuccessAction';
import { QueryListByModuleAction } from './QueryListByModuleAction';
import { UpdateRuleParameterAction } from './UpdateRuleParameterAction';
import { UpdateRuleParameterSuccessAction } from './UpdateRuleParameterSuccessAction';
import { GetParametersAction } from './GetParametersAction'
import { GetParametersSuccessAction } from './GetParametersSuccessAction'

export type Actions = EnableRuleAction | EnableRuleSuccessAction | DisableRuleAction | DisableRuleSuccessAction | UpdateRuleStatusAction | UpdateRuleStatusSuccessAction | UpdateRuleParameterAction | UpdateRuleParameterSuccessAction | GetParametersAction | GetParametersSuccessAction;
export type TypedActions<TModel> = QueryListByModuleAction<TModel>

export * from './EnableRuleAction';
export * from './EnableRuleSuccessAction';
export * from './DisableRuleAction';
export * from './DisableRuleSuccessAction';
export * from './UpdateRuleStatusAction';
export * from './UpdateRuleStatusSuccessAction';
export * from './QueryListByModuleAction';
export * from './UpdateRuleParameterAction';
export * from './UpdateRuleParameterSuccessAction';
export * from './GetParametersAction';
export * from './GetParametersSuccessAction';



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/index.ts